import PricingCtaButton from "@/core/infrastructure/repository/pricing/PricingCtaButton"
import hasData from "@/core/domain/specification/hasData"

export default class PricingCtaService {
    pricingCtaButton: PricingCtaButton

    constructor() {
        this.pricingCtaButton = new PricingCtaButton()
    }

    async process() {
        const { data, totalCount } = await this.pricingCtaButton.fetch()

        if (!hasData(totalCount)) {
            throw new TypeError("No data was provided")
        }

        return data
    }
}
